export default __webpack_public_path__ + "static/media/bR.c1ec7c64.svg";